<template>
  <div>
    <TipTap
      :content.sync="content"
      :editable="false"
      :style-settings="styleSettings"
      :style="{border: border}"
      iframe-extension
      mention-extension
      image-extension
      bubbles-legends-extension
      index-table-extension
    />
  </div>
</template>

<script lang="ts">
import { StoryKeys, StorySettingsConfig, NodeStoryKeys } from '@/types'
import Component from 'vue-class-component'

import TipTap from '@/components/TipTap/TipTap.vue'
import TTMixin from '@/components/TipTap/wrappers/TTMixin'

const components = {
  TipTap,
}

@Component({ components })
export default class TTReader extends TTMixin {
  get storySettings () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config.storySettings
  }

  get styleSettings () {
    if (this.panel === StoryKeys.INFO_FAQ || this.panel === StoryKeys.SPLASH_SCREEN) return this.storySettings[this.panel as keyof StorySettingsConfig]
    return {
      ...this.storySettings[this.panel as keyof StorySettingsConfig],
      fontColor: this.tabFontColor,
    }
  }

  get storyBuilderPanel () {
    return this.$typedStore.public.display.storyBuilderPanel
  }

  get storyBorder () {
    return this.$typedStore.public.display.storyBorder
  }

  get border () {
    if (this.storyBorder) {
      return this.panel === this.storyBuilderPanel ? 'dashed gray 3px' : ''
    } else {
      return ''
    }
  }

  get tabPath () {
    const { activeTab } = this.$typedStore.public.display
    return activeTab ? activeTab.path : ''
  }

  get tabFontColor () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.tabFontColor(this.tabPath, this.panel as Exclude<NodeStoryKeys, typeof StoryKeys.CUSTOM_DESCRIPTION | typeof StoryKeys.CUSTOM_TITLE>)
  }

  mounted () {
    this.$nextTick(() => {
      this.$forceUpdate()
    })
  }
}
</script>
